import React from 'react';
import { Activity } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RingsContainer } from './RingsContainer';
import { RingMetric } from './RingMetric';
import { RingsOverviewProps } from './types';
import { getMetricConfigs } from './utils';

export function RingsOverview({ metrics }: RingsOverviewProps) {
  const navigate = useNavigate();
  const metricConfigs = getMetricConfigs(metrics);

  const handleMetricClick = (tab: string) => {
    navigate('/home', { state: { tab } });
  };

  const centerContent = (
    <div className="flex flex-col items-center justify-center">
      <div className="relative">
        <Activity className="w-6 h-6 text-primary" />
        <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
      </div>
      <div className="text-sm font-bold bg-gradient-to-r from-primary via-purple-400 to-blue-500 bg-clip-text text-transparent">
        TODAY
      </div>
    </div>
  );

  return (
    <div className="relative p-[1px] rounded-lg">
      {/* Container Border */}
      <div className="absolute inset-0 rounded-lg">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/30 via-purple-500/30 to-primary/30 rounded-lg" />
      </div>

      {/* Inner Content */}
      <div className="relative bg-background rounded-lg p-6">
        {/* Static Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-purple-500/5 to-transparent opacity-30" />
        
        <div className="relative">
          <div className="flex justify-center">
            <div className="relative w-[160px] h-[160px]">
              {/* Side Metrics */}
              {metricConfigs.map((config) => (
                <RingMetric
                  key={config.tab}
                  config={config}
                  onClick={() => handleMetricClick(config.tab)}
                />
              ))}

              {/* Rings Container */}
              <RingsContainer 
                metrics={metrics} 
                centerContent={centerContent} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}